import { PROMO_IPHONE_18_IMAGES_URL } from '../assets/images'

import { BenefitCard } from './BenefitCard'

import cl from './BenefitsSection.module.scss'

const benefits = [
	{
		className: cl._cable,
		description: 'на&nbsp;комплект: <br/>телефон + аксессуар',
		banners: {
			desktop: {
				src: `${PROMO_IPHONE_18_IMAGES_URL}/card-3-1440.webp`,
				link: ''
			},
			mobile: {
				src: `${PROMO_IPHONE_18_IMAGES_URL}/card-3-375.webp`
			},
			tablet: {
				src: `${PROMO_IPHONE_18_IMAGES_URL}/card-3-768.webp`
			}
		},
		title: 'Выгода до&nbsp;5&nbsp;000&nbsp;₽',
		tooltip:
			'При покупке iPhone 18 Pro ӏ Pro Mаx у нас вы получаете выгоду до 5 000 ₽ на комплект: телефон + аксессуар.'
	},
	{
		className: cl._warranty,
		description: 'на новое устройство',
		banners: {
			desktop: {
				src: `${PROMO_IPHONE_18_IMAGES_URL}/card-4-1440.webp`,
				link: ''
			},
			mobile: {
				src: `${PROMO_IPHONE_18_IMAGES_URL}/card-4-375.webp`
			},
			tablet: {
				src: `${PROMO_IPHONE_18_IMAGES_URL}/card-4-768.webp`
			}
		},
		title: '2&nbsp;года гарантии',
		tooltip:
			'При покупке iPhone 18 Pro ӏ Pro Max y нас вы получаете 2 года гарантии. Гарантия на iPhone Duo составляет 12 месяцев.'
	},
	{
		className: cl._tradeIn,
		description: 'Дополнительная выгода',
		banners: {
			desktop: {
				src: `${PROMO_IPHONE_18_IMAGES_URL}/card-5-1440.webp`,
				link: ''
			},
			mobile: {
				src: `${PROMO_IPHONE_18_IMAGES_URL}/card-5-375.webp`
			},
			tablet: {
				src: `${PROMO_IPHONE_18_IMAGES_URL}/card-5-768.webp`
			}
		},
		title: '5&nbsp;000&nbsp;₽ по&nbsp;трейд-ин',
		tooltip:
			'При сдаче в трейд-ин старого iPhone (начиная от iPhone 14) вы получаете дополнительную скидку в размере 5 000 ₽ к оценочной стоимости вашего устройства на покупку нового iPhone 18 Pro ӏ Pro Max.'
	},
	{
		className: cl._finance,
		description: 'Возможность приобрести',
		banners: {
			desktop: {
				src: `${PROMO_IPHONE_18_IMAGES_URL}/card-6-1440.webp`,
				link: ''
			},
			mobile: {
				src: `${PROMO_IPHONE_18_IMAGES_URL}/card-6-375.webp`
			},
			tablet: {
				src: `${PROMO_IPHONE_18_IMAGES_URL}/card-6-768.webp`
			}
		},
		title: 'в&nbsp;рассрочку <span>0-0-36&nbsp;*</span>',
		tooltip:
			'При покупке iPhone 18 Pro ӏ Pro Max у нас вы можете воспользоваться выгодными кредитными предложениями от наших банков-партнёров.'
	}
] as const

export const BenefitsSection = () => {
	return (
		<section className={cl.root}>
			{/*<h2 className={cl.title}>Также вы получаете:</h2>*/}

			<div className={cl.cards}>
				{benefits.map(benefit => (
					<BenefitCard key={benefit.title} {...benefit} />
				))}
			</div>
		</section>
	)
}
